import { SnackbarProvider } from 'notistack';
import React from 'react';
import { createRoot } from 'react-dom/client';
import RejectedErrorsReporter from './RejectedErrorsReporter';
import './index.scss';
import App from './root/App';

const container = document.querySelector('#root');

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
	<React.StrictMode>
		<SnackbarProvider maxSnack={3} autoHideDuration={2500}>
			<RejectedErrorsReporter />
			<App />
		</SnackbarProvider>
	</React.StrictMode>,
);
